import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import CtaStyle2 from '../Cta/CtaStyle2';
import AboutStyle6 from '../About/AboutStyle6';
import CardStyle3 from '../Card/CardStyle3';
import { pageTitle } from '../../helpers/PageTitle';

export default function FinancingOptionsPage() {
  pageTitle('Financing Options - Soketry Solutions');

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Making Renewable Energy <br /> Accessible and Affordable"
        subTitle="Financing Options"
        shape="shape_3"
      />
      <Spacing lg="75" md="60" />
      <div className="cs_service_info">
        <div className="container">
          <div className="row align-items-center cs_gap_y_40">
            <div className="col-lg-6">
              <div
                className="cs_service_info_thumb cs_bg_filed"
                style={{
                  backgroundImage: 'url("/images/financing_options/financing-option-1.jpg")',
                }}
              />
            </div>
            <div className="col-lg-6">
              <div className="row cs_gap_y_40">
                <div className="col-sm-6">
                  <CardStyle3
                    number="01"
                    title="Flexible Payment Plans"
                    subTitle="Choose from various payment options tailored to your budget and financial situation."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="02"
                    title="Low Interest Rates"
                    subTitle="Benefit from competitive interest rates and favorable financing terms for your energy solutions."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="03"
                    title="Zero Down Payment"
                    subTitle="Start your renewable energy journey with no initial investment through our zero down payment options."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="04"
                    title="Government Incentives"
                    subTitle="Access available government rebates and tax incentives to maximize your savings on renewable energy."
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Spacing lg="150" md="80" />
      <AboutStyle6
        thumbnailSrc="/images/financing_options/financing-option-2.jpg"
        title="Smart Financing Solutions"
        subTitle="Our financing options are designed to make renewable energy accessible to everyone, with flexible terms and competitive rates to suit your needs."
        featureList={[
          'Customized Payment Plans',
          'Competitive Interest Rates',
          'Easy Application Process',
          'Quick Approval Times'
        ]}
        btnText="Explore Our Projects"
        btnUrl="/portfolio"
      />
      <Spacing lg="150" md="80" />
      <CtaStyle2
        title="Ready to Finance Your Energy Solution?"
        btnText="Get Started"
        btnUrl="/contact"
      />
      <Spacing lg="150" md="80" />
    </>
  );
}
